<template>
  <div v-if="theme">
    <app-header
      :title="(originalName) ? 'Edit ' + originalName: 'New Theme '"
      subtitle="Theme"
    >
      <b-button variant="primary" class="mr-2" @click="save">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <!--Category-->
            <b-form-group>
              <label>Category</label><i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-select v-model="theme.category_id" class="form-control">
                <b-form-select-option v-for="category in mediacategories" :key="category.id" :value="category.id">
                  {{ category.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <!--Name-->
            <b-form-group>
              <label>Name</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="theme.name"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <!--Tags-->
            <b-form-group>
              <label>Tags</label>
              <b-form-textarea v-model="theme.tags"></b-form-textarea>
              <small class="form-text text-muted">
                Comma-separated keywords to help users find this theme.
              </small>
            </b-form-group>
            <!--thumbnail-->
            <b-form-group>
              <label>Thumbnail</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <FileInput v-model="theme.src" required folder="theme/src" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import FileInput from '@/components/FileInput';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    FileInput,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      theme: null,
      mediacategories: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      await $api.get('/v1/internal/mediacategories').then((mediacategories) => {
        this.mediacategories = mediacategories;
      });
      if (this.$route.query.id) {
        await $api.get(`/v1/internal/themes/${this.$route.query.id}`).then((theme) => {
          this.originalName = theme.name;
          this.theme = theme;
        });
      } else {
        this.theme = {
          category_id: this.$route.query.category_id,
        };
      }
    },

    async save() {
      let theme;
      if (this.theme.id) {
        theme = await $api.put(`/v1/internal/themes/${this.theme.id}`, this.theme);
      } else {
        theme = await $api.post('/v1/internal/themes', this.theme);
      }
      this.$router.push({
        name: 'theme-detail',
        params: theme,
      });
    },
  },
};
</script>
